<template>
	<div id="reservation">
	    <div class="page-container" id="reservation-container">
	        <div class="page-content" id="reservation-content">
				<header id="main-menu" class="logo-header">
				    <div class="store-info menu-content">
				        <div class="logo-col">
				            <!--<img src="https://pic.streetaway.cn/uploads/4b/29/d4/48/07/fc19e24c99a90ae85c61d8.png">-->
				            <!-- <img :src="storeLogo"> -->

				        </div>
				        <div class="store-name">
				            <h1>{{storeName}}</h1>
				        </div>
				    </div>
				</header>
	            <div id="main-container">
	                <div class="errorModule">
	                    <div class="errorTitle">
	                        <h1>OOPS!</h1>
	                        <h3>500-Aha! You got an invalid store</h3>
	                    </div>
	                    <div class="errorBackLink">
	                        <a href="https://www.streetaway.co.uk/">go to homepage</a>
	                    </div>
	                </div>
	            </div>
	        </div>
	    </div>

	</div>

</template>

<script>
    export default {
        name: "InvalidStore",
  data() {
	return {
		storeLogo:'',
        storeName:'Error',
	}
  },
    }
</script>
<style scoped="scoped">
#reservation .errorBackLink{ margin-top: 30px;}
@media screen and (min-width: 640px) {
#reservation #main-container{ box-shadow: 5px 0 15px rgba(0,0,0,.2), -5px 0 15px rgba(0,0,0,.2); }
#reservation .errorModule a{ font-size: 30px; padding: 10px 20px;}
#reservation .errorContent{ font-size: 20px; padding: 5px 20px;}
   }
</style>



// WEBPACK FOOTER //
// src/page/InvalidStore.vue